import { POST_LOGIN_REDIRECT_URI_KEY_NAME } from "../utilities/auth.js";

export default function(to, from, next) {
	if (to.query?.next) {
		window.sessionStorage.setItem(POST_LOGIN_REDIRECT_URI_KEY_NAME, to.query.next);
	}
	next();
}
